import { Controller } from "@hotwired/stimulus";
import { positionPopover } from "../lib/position_popover";

export default class extends Controller {
  static targets = ["content"];
  static values = { placement: { type: String, default: "bottom" } };

  connect() {
    this.hide = this.hide.bind(this);
    this.closeOnEscape = this.closeOnEscape.bind(this);
    this.reposition = this.reposition.bind(this);
    document.addEventListener("click", this.hide);
    document.addEventListener("keydown", this.closeOnEscape);
  }

  disconnect() {
    document.removeEventListener("click", this.hide);
    document.removeEventListener("keydown", this.closeOnEscape);
    this.teardownPositioning();
  }

  toggle(event) {
    event.stopPropagation();
    if (this.contentTarget.classList.contains("d-none")) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.contentTarget.classList.remove("d-none");
    this.contentTarget.classList.add("show");
    // Fixed positioning so we don't care about ancestor offset parents;
    // !important is required to beat Bootstrap's `.position-*` utility classes,
    // which compile with !important by default.
    this.contentTarget.style.setProperty("position", "fixed", "important");
    this.reposition();
    window.addEventListener("scroll", this.reposition, true);
    window.addEventListener("resize", this.reposition);
  }

  reposition() {
    const { top, left } = positionPopover(this.element, this.contentTarget, {
      placement: this.placementValue,
    });
    this.contentTarget.style.top = `${top}px`;
    this.contentTarget.style.left = `${left}px`;
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close();
  }

  close() {
    this.contentTarget.classList.add("d-none");
    this.contentTarget.classList.remove("show");
    this.teardownPositioning();
  }

  teardownPositioning() {
    window.removeEventListener("scroll", this.reposition, true);
    window.removeEventListener("resize", this.reposition);
  }
}
